<script>
	import { onMount } from "svelte";
	import { fadeIn } from "@pernod-ricard-global-cms/jsanimations";
	onMount(() => {
		const socials = document.querySelector(".social-icons");
		setTimeout(() => {
			fadeIn(socials, 1000);
		}, 2500);
	});
</script>

<section class="social-icons">
	<a href="https://github.com/Ciaran79" target="_blank">
		<img class="social-icon" src="images/github-1.svg" alt="github" />
	</a>
	<a href="https://www.linkedin.com/in/ciaran-kamp" target="_blank">
		<img class="social-icon" src="images/linkedin-3.svg" alt="linkedin" />
	</a>
</section>

<style>
	.social-icons {
		opacity: 0;
		display: flex;
		justify-content: center;
		gap: 20px;
		margin-top: 40px;
	}
	.social-icon {
		width: 50px;
	}
</style>
